var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-menu',_vm._g(_vm._b({staticClass:"base-menu",attrs:{"content-class":"base-menu__content"},scopedSlots:_vm._u([_vm._l((_vm.$scopedSlots),function(index,name){return {key:name,fn:function(data){return [_vm._t(name,null,null,data)]}}})],null,true)},'v-menu',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }